import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { signInWithEmail, signInWithGoogle } from '../../services/authService';
import { Mail, Lock, Chrome } from 'lucide-react';
import { getAuthenticatedHomePath } from '../../utils/collaboratorPermissions';
import './Login.css';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { currentUser, userData } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Redirecionar se já estiver logado
  useEffect(() => {
    if (currentUser && userData) {
      // Se é colaborador sem currentCompanyId, vai para seleção de empresa
      if (userData.role === 'collaborator' && !userData.currentCompanyId) {
        navigate('/select-company', { replace: true });
      } else {
        navigate(getAuthenticatedHomePath(userData), { replace: true });
      }
    }
  }, [currentUser, userData, navigate]);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const { error: loginError } = await signInWithEmail(email, password);
    
    if (loginError) {
      setError(loginError);
    }
    
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError('');

    const { error: loginError } = await signInWithGoogle();
    
    if (loginError) {
      setError(loginError);
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/logo.png" alt="SDC Turismo" className="login-logo" />
          <h1>{t('app.name')}</h1>
          <p>{t('app.tagline')}</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleEmailLogin} className="login-form">
          <div className="input-group">
            <Mail size={20} />
            <input
              type="email"
              placeholder={t('auth.email')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <Lock size={20} />
            <input
              type="password"
              placeholder={t('auth.password')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? t('common.loading') : t('auth.login')}
          </button>
        </form>

        <div className="divider">
          <span>ou</span>
        </div>

        <button
          onClick={handleGoogleLogin}
          className="btn-google"
          disabled={loading}
        >
          <Chrome size={20} />
          {t('auth.signInWithGoogle')}
        </button>
      </div>
    </div>
  );
};

export default Login;
